import { Shell, StepFooter } from "@/components/Shell";
import { OptionList } from "@/components/OptionList";
import { IMMEDIATE_ALERTS } from "@/lib/questions";

const YES_NO = [
  { id: "yes", label: "Sí" },
  { id: "no", label: "No" },
];

export function ImmediateAlertsStep({ answers, setAnswer, onBack, onNext, progress, onUrgent }) {
  const handleChange = (id, v) => {
    setAnswer(id, v);
    if (v === "yes") {
      setTimeout(() => onUrgent(), 100);
    }
  };

  const canContinue = IMMEDIATE_ALERTS.every((q) => answers[q.id]);

  return (
    <Shell progress={progress}>
      <span className="cc-eyebrow">Alertas inmediatas</span>
      <h1 className="font-serif text-3xl sm:text-4xl mt-3">
        En este momento, ¿tienes alguno de estos síntomas?
      </h1>
      <p className="mt-3 text-[hsl(var(--muted-foreground))]">
        Si respondes “Sí” a cualquiera, te mostraremos información de urgencia.
      </p>

      <div className="mt-6 space-y-4">
        {IMMEDIATE_ALERTS.map((q) => (
          <div key={q.id} className="cc-card p-5">
            <p className="font-medium mb-3">{q.text}</p>
            <OptionList
              name={q.text}
              options={YES_NO}
              value={answers[q.id]}
              onChange={(v) => handleChange(q.id, v)}
              testIdPrefix={q.id}
            />
          </div>
        ))}
      </div>

      <StepFooter>
        <button onClick={onBack} className="cc-btn-outline" data-testid="immediate-back-btn">
          Atrás
        </button>
        <button
          onClick={onNext}
          disabled={!canContinue}
          className="cc-btn-primary"
          data-testid="immediate-next-btn"
        >
          Continuar
        </button>
      </StepFooter>
    </Shell>
  );
}
